module.exports = __webpack_public_path__ + "img/contacts-line.e60fe78f.png";